<input #value type="text" class="form-control" (input)="onUpdate($event.target.value)" value="{{ input.text  }}" style="width: 100%" >

